import { createAsyncAction } from "typesafe-actions";

import { HospitalActionTypes } from "./constants";
import {
  GetSensorsDataReportPayload,
  GetSessionsReportPayload,
  GetReportResponse,
  GetDetailedSensorsDataReportPayload,
  GetDetailedUnfilteredSensorsDataReportPayload,
} from "../interfaces";

export const getSessionsReport = createAsyncAction(
  HospitalActionTypes.GET_SESSIONS_REPORT,
  HospitalActionTypes.GET_SESSIONS_REPORT_SUCCESS,
  HospitalActionTypes.GET_SESSIONS_REPORT_FAILURE,
)<GetSessionsReportPayload, GetReportResponse, Error>();

export const getSensorsDataReport = createAsyncAction(
  HospitalActionTypes.GET_SENSORDS_DATA_REPORT,
  HospitalActionTypes.GET_SENSORDS_DATA_REPORT_SUCCESS,
  HospitalActionTypes.GET_SENSORDS_DATA_REPORT_FAILURE,
)<GetSensorsDataReportPayload, GetReportResponse, Error>();

export const getDetailedSensorsDataReport = createAsyncAction(
  HospitalActionTypes.GET_DETAILED_SENSORDS_DATA_REPORT,
  HospitalActionTypes.GET_DETAILED_SENSORDS_DATA_REPORT_SUCCESS,
  HospitalActionTypes.GET_DETAILED_SENSORDS_DATA_REPORT_FAILURE,
)<GetDetailedSensorsDataReportPayload, string, Error>();

export const getDetailedUnfilteredSensorsDataReport = createAsyncAction(
  HospitalActionTypes.GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT,
  HospitalActionTypes.GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT_SUCCESS,
  HospitalActionTypes.GET_DETAILED_UNFILTERED_SENSORDS_DATA_REPORT_FAILURE,
)<GetDetailedUnfilteredSensorsDataReportPayload, string, Error>();
